import { Grid, Tab, Tabs, styled } from "@mui/material";

import { NETWORK_TYPES } from "pages/Deposit/constants";
import { useFormContext } from "react-hook-form";

export function CoinTypeTab({ coinList, onChange }) {
  const { watch } = useFormContext();
  const isDigital = watch("isDigital");

  const handleChangeTab = (_, tab) => {
    const tempIsDigital = tab === NETWORK_TYPES.crypto.networkId;

    const coinWithCurrentIsDigital = coinList?.lisCoin?.find(
      (coin) => coin?.isDigital === tempIsDigital
    );

    onChange(coinWithCurrentIsDigital);
  };

  const currentTab = isDigital
    ? NETWORK_TYPES.crypto.networkId
    : NETWORK_TYPES.fiat.networkId;

  return (
    <Grid item xs={12}>
      <TabsStyle
        value={currentTab}
        onChange={handleChangeTab}
        aria-label="secondary tabs example"
      >
        {Object.values(NETWORK_TYPES)?.map((data, index) => (
          <Tab value={data.networkId} label={data.networkName} key={index} />
        ))}
      </TabsStyle>
    </Grid>
  );
}

const TabsStyle = styled(Tabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.modules.border}`,
  marginTop: theme.spacing(3),
  marginBottom: theme.spacing(3),

  ".MuiTabs-flexContainer": {
    justifyContent: "space-around",

    [theme.breakpoints.up("md")]: {
      justifyContent: "flex-start",
      ".MuiButtonBase-root": {
        marginRight: theme.spacing(4),
      },
    },
  },
}));

export default CoinTypeTab;
